import type { ListBuilderList } from '../../../types';

/**
 * Recently Changed list - licenses where the registry detected a status
 * change in the last 7 days.
 *
 * Uses a cross-DB join from client_license_match to lm_registry_changes
 * to surface licenses whose authoritative registry data has been updated,
 * so compliance officers can review what changed.
 */
export const recentlyChangedList: ListBuilderList = {
	id: 'default-licenses-recently-changed',
	cacheTTL: 300000,
	name: 'Recently Changed',
	type: 'default',
	active: true,
	sortOrder: 1,
	filterRules: {
		licenseRecentlyChanged: {
			defaultValue: { id: 'yes', label: 'Yes' },
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	inheritsFrom: 'default-licenses-all',
};
